var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _polygon;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClientLogos01ArtStation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f3f3f3;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M323.37,122l29.57,88.15H336.66l-6.27-19.51H299.91l-6,19.55H277.61L307.19,122Zm-18.93,54.15h21.4l-10.91-34.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M365.36,210.12V122.26h37.23c15.3,0,24.44,9.26,24.44,19.31v18.66c0,7-4.75,13.83-13,17.19l14.79,32.7h-17l-13.83-30.84H381.74v30.84Zm16.3-73.32v28.07h19.68c5.19,0,9.53-3,9.53-8.14V145.07c0-5.39-4.51-8.27-10.17-8.27Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M459.25,210.12V136.67H437.44V122.26h58v14.41H475.43v73.45Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M515.15,185.06v5.58c0,7.78,7.28,13.67,16.68,13.67H542.2c9.65,0,17.17-4.65,17.17-12.79v-6.07c0-13.53-48.51-16-48.51-39.23V138.3c0-8.9,8.4-16.68,19.67-16.68H542.2c12.66,0,21.94,8.4,21.94,18.06v7.9h-7.28v-6.65c0-7.26-6.76-12.78-15.28-12.78h-10c-7.4,0-13.42,4.88-13.42,11.27v6.4c0,17.28,48.52,19.55,48.52,38.61v8.4c0,11-10.16,18-23.82,18H531.54c-13.66,0-23.68-8.78-23.68-19v-6.78Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M602.91,210.12V128.77H578.33v-6.39h55.31v6.39H610.17v81.35Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M672.85,121.76l30.95,88.36h-7.38L686.64,182H651.53l-9.64,28.19h-7.4l31.11-88.36Zm-19,53.58h30.58l-15.28-44.25Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M729.51,210.12V128.77H704.94v-6.39h55.32v6.39H736.78v81.35Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M776.52,210.12V122.38h7.26v87.74Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M828.85,210.88c-12.1,0-20.75-8.78-20.75-19V140.68c0-10.28,8.78-19,20.75-19h17.42c11.91,0,20.55,8.78,20.55,19v51.15c0,10.27-8.64,19-20.55,19Zm16.8-6.52A13.59,13.59,0,0,0,859.47,191c0-.1,0-.2,0-.3V141.81A13.59,13.59,0,0,0,846,128.15H829.23a13.59,13.59,0,0,0-13.91,13.26c0,.13,0,.26,0,.4v48.83a13.59,13.59,0,0,0,13.5,13.68h.42Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M891.21,210.12V122.38h7.52l44,75V122.26H950v87.86h-7.52l-44-75.09v75.09Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50,210.1l15.44,26.71h0A18.41,18.41,0,0,0,81.91,247H184.45L163.18,210.1Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M232.83,210.29a18.35,18.35,0,0,0-2.94-10L169.82,95.86a18.46,18.46,0,0,0-16.31-9.81H121.75L214.54,246.8l14.62-25.32C232.05,216.57,232.83,214.48,232.83,210.29Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "148.06 183.91 106.59 112.09 65.13 183.91 148.06 183.91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientLogos01ArtStation);
export default __webpack_public_path__ + "static/media/Client Logos – 01 – ArtStation.f97920367e21f0aad8c1e161c6aa618c.svg";
export { ForwardRef as ReactComponent };